import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import type { SwatchSize } from './shared/types';

const Svg = styled.svg`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
`;

const WhiteLine = styled.line`
    stroke: #ffffff;
`;

const BlackLine = styled.line`
    stroke: #000000;
`;

type DiagonalLinesProps = {
    size?: SwatchSize;
} & HTMLAttributes<SVGElement>;

export default function DiagonalLines({ size, ...restProps }: DiagonalLinesProps) {
    const lineWidth = size !== 'lg' ? 2 : 1;
    const lineWidthHalf = lineWidth / 2;

    return (
        <Svg {...restProps}>
            <BlackLine
                x1={`${lineWidthHalf}%`}
                y2={`${lineWidthHalf}%`}
                y1={`${100 + lineWidthHalf}%`}
                x2={`${100 + lineWidthHalf}%`}
                strokeWidth={`${lineWidth}`}
            />
            <WhiteLine
                x1={`-${lineWidthHalf}%`}
                y2={`-${lineWidthHalf}%`}
                y1={`${100 - lineWidthHalf}%`}
                x2={`${100 - lineWidthHalf}%`}
                strokeWidth={`${lineWidth}`}
            />
        </Svg>
    );
}
